<script>
import moment from 'moment-timezone'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import Loading from '@/components/Loading.vue'
import { EventBus, Topics, Types } from '@/event-bus'
import validationFormMixin from '@/mixins/validation.mixin'
import http from '@/utils/http'
import { toUtcIsoString } from '@/utils/transform'
import { validaData } from '@/utils/validations/date'

export default {
  name: 'ConsultarExpressao',
  components: { Loading },
  mixins: [validationMixin, validationFormMixin],
  props: {
    sensorId: {
      type: String,
      required: false,
    },
    expressao: {
      type: String,
      required: true,
    },
  },
  validations: {
    form: {
      expressao: { required },
      inicio: { required },
      fim: { required },
    },
  },
  data() {
    return {
      form: {
        expressao: '',
        inicio: null,
        fim: null,
        duracao: '12:00',
      },
      errorDuracao: null,
      loading: false,
      resultado: null,
      funcoes: [],
    }
  },
  beforeMount() {
    if (this.expressao) {
      this.form.expressao = this.expressao
    }

    http.get(`sensor/virtual/funcoes`).then((response) => {
      this.funcoes = response.funcoes
    })
  },
  methods: {
    async consultar() {
      this.loading = true
      this.resultado = null

      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.loading = false
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Preencha as datas corretamente',
        })
        return
      }

      const result = await http.post(
        `sensor/${this.sensorId}/virtual/evaluate`,
        {
          expressao: this.form.expressao,
          inicio: toUtcIsoString(this.form.inicio),
          fim: toUtcIsoString(this.form.fim),
        },
        false
      )

      if (result) {
        this.resultado = result
      } else {
        EventBus.$emit(Topics.NOTIFICATIONS, {
          type: Types.WARNING,
          message: 'Erro ao consultar expressão',
        })
      }

      this.loading = false
    },
    gerarPeriodo() {
      this.errorDuracao = null
      if (validaData(this.form.duracao) === false) {
        this.errorDuracao = 'Duração inválida'
        return
      }

      const duracao = this.form.duracao.split(':')

      const today = new Date()
      today.setMinutes(today.getMinutes() + 1)

      const inicio = new Date()
      inicio.setHours(today.getHours() - parseInt(duracao[0]))
      inicio.setMinutes(today.getMinutes() - parseInt(duracao[1]))

      this.form.inicio = moment(inicio).format('YYYY-MM-DD HH:mm')
      this.form.fim = moment(today).format('YYYY-MM-DD HH:mm')
    },
  },
}
</script>

<template>
  <div>
    <div class="row">
      <div class="col-4">
        <span class="md-subheading">Inicio</span>
        <VueCtkDateTimePicker v-model="form.inicio" format="YYYY-MM-DD HH:mm" />
      </div>
      <div class="col-4">
        <span class="md-subheading">Fim</span>
        <VueCtkDateTimePicker v-model="form.fim" format="YYYY-MM-DD HH:mm" />
      </div>

      <div class="col-1">
        <md-field
          :class="{
            'md-invalid': errorDuracao,
          }"
        >
          <label for="expressaoDuracao">Duração</label>
          <md-input
            id="expressaoDuracao"
            v-model="form.duracao"
            v-mask="'##:##'"
            name="expressaoDuracao"
          />
          <span v-if="errorDuracao" class="md-error">{{ errorDuracao }}</span>
        </md-field>
      </div>

      <div class="col-3">
        <md-button class="md-primary mt-3" @click="gerarPeriodo">
          Gerar periodo
        </md-button>
        <md-tooltip md-direction="top">
          Gerar periodo a partir do horário atual
        </md-tooltip>
      </div>
    </div>

    <div>
      <span class="md-title">Funções</span>
      <div style="display: grid; grid-template-columns: repeat(3, 1fr)">
        <div v-for="funcao in funcoes" :key="funcao.nome" class="p-1">
          <span class="md-list-item-text">{{ funcao.nome }}</span>
          <md-tooltip md-direction="left">
            {{ funcao.descricao }}
          </md-tooltip>
        </div>
      </div>
    </div>

    <md-field :class="getValidationClass('expressao')">
      <label for="expressaoExpressao">Expressão</label>
      <md-input
        id="expressaoExpressao"
        v-model="form.expressao"
        name="expressaoDuracao"
      />
      <span v-if="!$v.form.expressao" class="md-error"
        >Expressão é obrigatório</span
      >
    </md-field>

    <div class="row">
      <div class="col-6">
        <div style="text-align: center">
          <md-progress-spinner
            v-if="loading"
            :md-diameter="40"
            :md-stroke="5"
            md-mode="indeterminate"
          />
        </div>

        <div v-if="!loading && !!resultado">
          <span class="md-subheading">Resultado: {{ resultado.result }}</span>
          <div>Levou {{ resultado.tempoExecucao }}</div>
        </div>
      </div>
      <div class="col-6" style="text-align: right">
        <md-button class="md-accent" @click="$emit('close')">
          Fechar
        </md-button>
        <md-button
          class="md-raised md-primary"
          :disabled="loading"
          @click="consultar"
        >
          Consultar
        </md-button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
